module.exports = __webpack_public_path__ + "static/userflows@2x-8ba3b14b3894d08c7f68256b9d696179.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/labs/userflows@2x.jpg
// module id = 2660
// module chunks = 134932258599989